<ng-container *ngTemplateOutlet="(chatMessages?.length || (shouldShowLoading$ | async)) ? messages : placeholder" />
<p-ai-chat-window-prompt-bar *ngIf="showPromptBar" [disabled]="assistantThinking" [disabledSubmit]="assistantWorking"
                             (onTriggerPrompt)="scrollToLastMessage()"/>

<!-- #region Templates -->
<ng-template #messages>
    <div class="messages">
        <div #messagesScrollable class="messages-scrollable messages-log title-bar-shadow"
             pStickToBottom (canScrollDownChange)="onCanScrollDownChange($event)" (scroll)="onScroll($event)">
            <p-ai-chat-window-message
                *ngFor="let message of chatMessages; trackBy: messageIndex; let last = last"
                [message]="message"
                [linkPrefix]="linkPrefix"
                [assistantWorking]="assistantWorking"
            >
                <ai-writing-indication
                    *ngIf="last && showInlineIndication && isAiMessage(message)"
                    [inline]="true"
                    [state]="thinkingEvent.state"
                    [translationKey]="thinkingEvent.translationKey"
                    [translationParams]="thinkingEvent.translationParams"
                ></ai-writing-indication>
            </p-ai-chat-window-message>
            <ng-container *ngComponentOutlet="logFooterComponent"></ng-container>
            <ai-writing-indication [hidden]="!assistantThinking" [state]="thinkingEvent.state" [translationKey]="thinkingEvent.translationKey" [translationParams]="thinkingEvent.translationParams"></ai-writing-indication>
        </div>
        <div *ngIf="showScrollToBottom" class="scroll-to-bottom-wrapper">
            <p-action-button-floating
                iconName="arrow-down"
                ariaLabel="Scroll to bottom"
                (buttonClicked)="scrollToBottom()"
            ></p-action-button-floating>
        </div>
    </div>
</ng-template>

<ng-template #placeholder>
    <div class="messages messages-placeholder">
        <div class="empty-state">
            <img class="illustration" [src]="emptyStateImageURL | widgetResourceUrl"/>
            <p class="text-placeholder">{{ 'aichat.chat.empty_state.title' | translate }}</p>
            <p class="text-placeholder-subtitle">{{ 'aichat.chat.empty_state.description_1' | translate }}</p>
            <p class="text-placeholder-subtitle">{{ 'aichat.chat.empty_state.description_2' | translate }}</p>
        </div>
    </div>
    <ng-container *ngLet="suggestionsFetchTrigger$ | async">
        <ai-chat-suggestions *ngIf="suggestions" [suggestions]="suggestions"></ai-chat-suggestions>
    </ng-container>
</ng-template>
<!-- #endregion -->
